import type { ComputedRef } from 'vue'
import type { Maybe } from '@/types'

import { isEmpty, isNotEmpty, isRecord } from '@/helpers'
/**
 * @returns {true | string} - true - валидно, string - текст ошибки
 * */
export function validateEmail(
  value: Maybe<string>,
  errorText = 'Введите действительную электронную почту'
): true | string {
  const regExp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g

  return !(value && regExp.test(value)) ? errorText : true
}
/**
 * @returns {true | string} - true - валидно, string - текст ошибки
 * */
export function validateNotEmpty(
  value: any,
  errorText = 'Заполните поле'
): true | string {
  return (isRecord(value) && !isEmpty(value)) || isNotEmpty(value)
    ? true
    : errorText
}
export function computedValidate(
  value: any,
  computedValue: ComputedRef,
  callback: (computedProp: ComputedRef, currentValue: typeof value) => boolean,
  errorText = 'Заполните поле правильно'
) {
  return callback(computedValue, value) ? true : errorText
}
